
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/journal/[page]",
      function () {
        return require("private-next-pages/journal/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/journal/[page]"])
      });
    }
  